export default function ContactSection() {
  return (
    <footer className="relative bg-background-950 px-4 md:px-6 py-20 md:py-28">
      <article className="max-w-6xl mx-auto">
        <div className="border-t border-white/10 pt-16 md:pt-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            <div>
              <h4 className="text-white/40 text-xs tracking-widest uppercase mb-6" style={{ fontFamily: 'var(--font-label)' }}>
                Location
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
                Padriku tee 4/4-12
                <br />
                Tallinn
                <br />
                11912
                <br />
                Estonia
              </p>
            </div>

            <div>
              <h4 className="text-white/40 text-xs tracking-widest uppercase mb-6" style={{ fontFamily: 'var(--font-label)' }}>
                Direct Line
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
                +372 56101659
              </p>
            </div>

            <div>
              <h4 className="text-white/40 text-xs tracking-widest uppercase mb-6" style={{ fontFamily: 'var(--font-label)' }}>
                Electronic Address
              </h4>
              <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
                contact@elrdigital.com
              </p>
            </div>

            <div className="flex items-end">
              <p className="text-white/30 text-sm italic" style={{ fontFamily: 'var(--font-heading)' }}>
                &copy; {new Date().getFullYear()}
                <br />
                All rights reserved
              </p>
            </div>
          </div>
        </div>
      </article>
    </footer>
  );
}